import { UploadedFileDto } from "@services/web-api-client";

export class FileUtils {
    public static downloadFile(response: { content?: string, contentType?: string, fileName?: string }) {
        if (!response || !response.content) return;

        const binaryString = window.atob(response.content);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        const blob = new Blob([bytes], {type: response.contentType});
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        if (response.fileName) {
            link.download = response.fileName;
        }
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }

    public static mapFilesToDto(files: File[]): Promise<UploadedFileDto[]> {
        return Promise.all(
            files.map(file => new Promise<UploadedFileDto>((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => {
                    const base64String = (reader.result as string).split(',')[1];
                    resolve(new UploadedFileDto({
                        fileName: file.name,
                        contentType: file.type,
                        content: base64String
                    }));
                };
                reader.onerror = reject;
                reader.readAsDataURL(file);
            }))
        );
    }
}
